import React from 'react';
import { MessageSquare } from 'lucide-react';
import { validateChatMentions, type ChatMention } from '../shared/chatMentions';

interface Props {
  text: string;
  mentions?: ChatMention[];
  onOpenChat?: (id: string) => void;
  overlay?: boolean;
}

export default function ChatMentionText({ text, mentions, onOpenChat, overlay = false }: Props) {
  const valid = validateChatMentions(mentions ?? [], text) ?? [];
  const parts: React.ReactNode[] = [];
  let offset = 0;
  for (const mention of valid) {
    parts.push(text.slice(offset, mention.start));
    parts.push(<span key={`${mention.start}:${mention.chatId}`} role={onOpenChat ? 'link' : undefined}
      tabIndex={onOpenChat ? 0 : undefined} title={`Abrir chat: ${mention.title}`}
      onClick={() => onOpenChat?.(mention.chatId)}
      onMouseDown={overlay ? (event) => event.preventDefault() : undefined}
      onKeyDown={(event) => {
        if (onOpenChat && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); onOpenChat(mention.chatId); }
      }}
      className={`text-juris ${onOpenChat ? 'cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-juris' : ''} ${overlay ? 'pointer-events-auto' : ''}`}
    ><span className="relative" aria-hidden="true">
      {/* Keep the literal glyph's width so the textarea caret and overlay stay aligned. */}
      <span className="invisible">@</span>
      <MessageSquare className="absolute left-0 top-1/2 h-[0.85em] w-[0.85em] -translate-x-0.5 -translate-y-1/2" aria-hidden="true" />
    </span>{mention.title}</span>);
    offset = mention.end;
  }
  parts.push(text.slice(offset));
  return <>{parts}</>;
}
